import VendorFactoryForm from './VendorFactoryForm';
import VendorFactoryList from './VendorFactoryList';

export {
    VendorFactoryForm,
    VendorFactoryList
};
